
import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import {
  Button,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
   Table,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import { toast } from "react-toastify";
import axios from "axios";
import BaseUrl from "../../base-api";
import { useNavigate } from "react-router-dom";
import moment from "moment";
const Admissions = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("");
  const [payment, setPayment] = useState(false);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [timer, setTimer] = useState(0);
  const resendDelay = 60;
  const [lastDate, setLastDate] = useState('');
  const today = moment().startOf('day');
  const [formData, setFormData] = useState({
    candidateName: "",
    email: "",
    fatherName: "",
    mobileNumber: "",
    whatsappNumber: "",
    dateOfBirth: "",
    referenceCode: "",
  });


  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer(prevTimer => prevTimer - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);


  const [errors, setErrors] = useState({});

  useEffect(() => {
    axios.get(`${BaseUrl}/reg/registration`).catch((error) => {

    });
    setLastDate(moment('2027-03-31', 'YYYY-MM-DD'));

  }, []);

  const handleChangeReg = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleOtpChange = (event) => {
    setOtp(event.target.value);
  };

  const validateMobileNumber = () => {
    const mobilePattern = /^[0-9]{10}$/;
    return mobilePattern.test(formData.mobileNumber);
  };
  const validateWhatsappNumber = () => {
    const mobilePattern = /^[0-9]{10}$/;
    return mobilePattern.test(formData.whatsappNumber);
  };

  const validateFieldsForOtp = () => {
    const { candidateName, email, fatherName } = formData;
    return (
      candidateName &&
      email &&
      fatherName &&
      validateMobileNumber() &&
      validateWhatsappNumber()

    );
  };

  const registration = async (event) => {
    event.preventDefault();

    try {
      setIsLoading(true);
      setLoadingMessage("Saving your details....");
      const response = await axios.post(`${BaseUrl}/reg/registration`, {
        ...formData,
        otp,
      });
      if (response.status === 200) {
        toast.success(response.data.message, {
          className: "toast-large",
          position: "top-center",
        });
        setLoadingMessage("Waiting for payment confirmation....");
        navigate("/login")

      } else {
        toast.error(response.data.message, { position: "top-center" });
      }
    } catch (error) {
      toast.error(error.response.data.message, { position: "top-center" });
    }
  };

  const sendOtp = async () => {
    if (validateFieldsForOtp() && validateFieldsDetails()) {
      try {
        const response = await axios.post(`${BaseUrl}/notification/sendOtp`, {
          mobileNumber: formData.mobileNumber,
          email: formData.email,
          referenceCode: formData.referenceCode
        });
        if (response.status === 200) {
          toast.success(response.data.message);
          setIsOtpSent(true);
          setTimer(resendDelay);
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {

        toast.error(error.response.data.message);
      }
    } else {
      toast.error("Please fill out all fields correctly before proceeding further.");
    }
  };

  const validateFields = (event) => {
    event.preventDefault();
    const { mobileNumber, referenceCode, ...otherFields } = formData;

    const allFieldsFilled = Object.values(otherFields).every(
      (value) => value !== ""
    );
    const mobileNumberValid = validateMobileNumber();

    if (!allFieldsFilled) {
      toast.error("Kindly fill all the required details", {
        position: "bottom-center",
      });
    } else if (!mobileNumberValid) {
      toast.error("Mobile number must be exactly 10 digits", {
        position: "bottom-center",
      });
    } else {
      registration(event);
    }
  };


  const [array, setArray] = useState({
    applicantName: "",
    applicationStatus: "",
    course: "",
    mobileNumber: "",
  });

  const [mobileNumber, setMobileNumber] = useState('');
  const imgRef = useRef(null);
  const [courses, setCourses] = useState([]);
  const [infoData, setInfoData] = useState({});
  const [alreadySubmitted, setAlreadySubmitted] = useState(true);
  const [resubmission, setResumbission] = useState(false);
  const [year, setYear] = useState([]);
  const [month, setMonth] = useState([]);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [boards, setBoards] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [ndocuments, setNdocuments] = useState([]);
  const [isemployee, setIsemployee] = useState(false);
  const containerRef = useRef(null);

//   const [isLoading, setIsLoading] = useState(false);
//   const [payment, setPayment] = useState(false);
//   const [loadingMessage, setLoadingMessage] = useState('');
  const [imageBlob, setImageBlob] = useState(null);
  const [modal, setModal] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  const [selectedParentCourse, setSelectedParentCourse] = useState('');
  const [selectedOtherCourse, setSelectedOtherCourse] = useState([]);
  const [selectedParentCourseBack, setSelectedParentCourseBack] = useState([]);
  const [selectedOtherCourseBack, setSelectedOtherCourseBack] = useState([]);

  const [regDetails, setRegDetails] = useState({

    employee: "",
    board: "",
    // schoolName: '',
    schoolYear: "",
    schoolMonth: "",
    rollNumber: "",
    country: "",
    state: "",
    district: "",
    address: "",
    pincode: "",
    marksObtained: "",
    totalMarks: "",
  });





  useEffect(() => {
    if (imageBlob && imgRef.current) {
      const renderImage = async () => {
        try {
          const url = URL.createObjectURL(imageBlob);
          imgRef.current.src = url;
        } catch (error) {
          toast.error('Error rendering image');
          console.error(error);
        }
      };
      renderImage();
    }
  }, [imageBlob]);
  const [marksdata, setMarksdata] = useState({
    totalMarks: 0,
    marksObtained: 0
  });
  const marksChange = (e) => {
    const { name, value } = e.target;

    setMarksdata({
      ...marksdata,
      [name]: parseInt(value)
    });
  };

  const validateMarks = () => {
    return marksdata.marksObtained <= marksdata.totalMarks;
  };

  useEffect(() => {
    axios
      .get(`${BaseUrl}/reg/fetchApplicationStatus`, {
        headers: { Authorization: localStorage.getItem("$3ingT0k3n") },
      })
      .then(function (response) {

        if (response.data.status === null) {


          setRegDetails({
            course: response.data.course,
            employee: response.data.employee,
            board: response.data.board,
            schoolYear: response.data.schoolYear,
            schoolMonth: response.data.schoolMonth,
            rollNumber: response.data.rollNumber,
            country: response.data.country,
            state: response.data.state,
            district: response.data.district,
            address: response.data.address,
            pincode: response.data.pincode,
            marksObtained: response.data.marksObtained,
            totalMarks: response.data.totalMarks,

          })
          setSelectedParentCourseBack(response.data.parentCourse)


          setSelectedOtherCourseBack(response.data.otherCourses)
          setAlreadySubmitted(false);
          fetchStates(response.data.country);
          fetchDistricts(response.data.state);
          setMobileNumber(response.data.mobileNumber);
        }
        else if (response.data.status === 'Rejected') {
          setRegDetails({
            course: response.data.course,
            employee: response.data.employee,
            board: response.data.board,
            schoolYear: response.data.schoolYear,
            schoolMonth: response.data.schoolMonth,
            rollNumber: response.data.rollNumber,
            country: response.data.country,
            state: response.data.state,
            district: response.data.district,
            address: response.data.address,
            pincode: response.data.pincode,
            marksObtained: response.data.marksObtained,
            totalMarks: response.data.totalMarks,

          })
          setSelectedParentCourseBack(response.data.parentCourse)


          setSelectedOtherCourseBack(response.data.otherCourses)
          setAlreadySubmitted(false);
          setResumbission(true);
          fetchStates(response.data.country);
          fetchDistricts(response.data.state);
          setMobileNumber(response.data.mobileNumber);
        } else {
          setInfoData(response.data);
        }
      })
      .catch(function (error) {
        toast.error(error);
      });
    axios
      .get(`${BaseUrl}/reg/registrationDto`)
      .then(function (response) {
        setCourses(response.data.courses);
        setYear(response.data.year);
        setMonth(response.data.month);
        setCountries(response.data.countries);
        setBoards(response.data.boards);
        setDocuments(response.data.documents);
      })
      .catch(function (error) {
        toast.error(error);
      });
  }, []);
  useEffect(() => {
    if (regDetails.employee) hidedoc();
  }, [regDetails.employee]);
  const fetchStates = (val) => {
    if (val != "" && val != undefined) {
      axios
        .get(`${BaseUrl}/reg/fetchStates?country=` + val, {
          headers: { Authorization: localStorage.getItem("$3ingT0k3n") },
        })
        .then(function (response) {
          setStates(response.data);
        });
    } else {
      setStates([]);
    }
  };
  const fetchDistricts = (e) => {
    if (e != "" && e != undefined) {
      axios
        .get(`${BaseUrl}/reg/fetchDistricts?state=` + e, {
          headers: { Authorization: localStorage.getItem("$3ingT0k3n") },
        })
        .then(function (response) {
          setDistricts(response.data);
        });
    } else {
      setDistricts([]);
    }
  };
  /*************  ✨ Codeium Command 🌟  *************/
  const handleChange = (e) => {
    let errorMessage = "";

    const value = e.target.value;
    if (e.target.classList != undefined)
      e.target.classList.remove("highlighted-input");
    // e.target.blur();
    if (e.target.type != undefined) {
      switch (e.target.type) {
        case "document":
          const fileType = e.target.value.type;
          if (
            ![
              "image/jpeg", "image/jpg", "image/png"
            ].includes(fileType)
          ) {
            toast.error("Only JPG, JPEG, or PNG files are allowed for document uploads.");
            document.getElementById(e.target.id).value = null;
            return;
          }
          else if (e.target.value.size > 1024 * 1024) {
            toast.error("File size should be less than 1MB");
            document.getElementById(e.target.id).value = null;
            return;
          }
          else if
            (
            e.target.value.size > 1024 * 1024) { }
          let doclist = ndocuments;
          doclist = doclist.filter((f) => f.docName !== e.target.name);
          doclist.push({
            docName: e.target.name,
            multipartFile: e.target.value,
          });
          setNdocuments(doclist);
          break;
        default:
          switch (e.target.name) {
            case "marksheet":
              if (value && !["image/jpeg", "image/jpg"].includes(value.type)) {
                errorMessage = "Only JPG/JPEG files are allowed";
              } else if (value && value.size > 1024 * 1024) {
                errorMessage = "File size should be less than 1MB";
              }
              break;
            case "uniCert":
              if (value && !["image/jpeg", "image/jpg"].includes(value.type)) {
                errorMessage = "Only JPG/JPEG files are allowed";
              } else if (value && value.size > 1024 * 1024) {
                errorMessage = "File size should be less than 1MB";
              }
              break;
            case "photograph":
              if (value && !["image/jpeg", "image/jpg"].includes(value.type)) {
                errorMessage = "Only JPG/JPEG files are allowed";
              } else if (value && value.size > 1024 * 1024) {
                errorMessage = "File size should be less than 1MB";
              }
              break;
            case "signature":
              if (value && !["image/jpeg", "image/jpg"].includes(value.type)) {
                errorMessage = "Only JPG/JPEG files are allowed";
              } else if (value && value.size > 1024 * 1024) {
                errorMessage = "File size should be less than 1MB";
              }
              break;
            case "marksObtained":
              if (!/^\d*$/.test(value)) {
                errorMessage = "Only numbers allowed";
              }
              break;
            case "totalMarks":
              if (!/^\d*$/.test(value)) {
                errorMessage = "Only numbers allowed";
              }
              break;
            case "pincode":
              if (!/^\d*$/.test(value)) {
                errorMessage = "Only numbers allowed";
              }
              break;
            case "rollNumber":
              if (!/^\d*$/.test(value)) {
                errorMessage = "Only numbers allowed";
              }
              break;

            default:
              break;
          }


          break;
      }
    }
    if (e.target.name === "employee" && e.target.value === "No") {
      setNdocuments([]);
    }
    if (errorMessage.length > 0) {
      e.target.blur();
      e.target.classList.add("highlighted-input");
      toast.error(errorMessage, { position: "top-center" });
    }
    setRegDetails((prevData) => ({
      ...prevData,
      [e.target.name]: value,
    }));
  };
  /******  cb7a92be-cf46-4ca2-af18-4c9351088960  *******/

  const postDetails = async () => {
    try {
        
      const data = new FormData();

      for (const key in regDetails) {
        if (key !== "documentsDto") {
          data.append(key, regDetails[key]);
        }
      }

      data.append("parentCourse", selectedParentCourse);

      if (!resubmission) {
        selectedOtherCourse.forEach((course, index) => {
          data.append(`otherCourses[${index}]`, course.value);
        });
      }
      else {
        data.append(`otherCourses`, selectedOtherCourseBack);
      }

      ndocuments.forEach((doc, index) => {
        data.append(`documentsDto[${index}].docName`, doc.docName);
        data.append(
          `documentsDto[${index}].multipartFile`,
          doc.multipartFile
        );
      });

for (const key in formData) {
      data.append(key, formData[key]);
    }

    data.append("otp", otp);


      const response = await axios.post(
        `${BaseUrl}/mcp/registration`,data,
        {
          headers: {
            Authorization: localStorage.getItem("$3ingT0k3n"),
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.status == 200) {
        toast.success(response.data.message, {
          className: "toast-large",
          position: "top-center",
        }); 
        navigate("/SideBar/admissions");
        // if(resubmission){
        //   navigate("/SideBar/my-courses");
        // } else{
        //   submitPaymentForm(response.data);
        // }

      } else toast.error(response.data.message, { position: "top-center" });
    } catch (error) {
      toast.error(error.response.data.message, { position: "top-center" });
    }
  };
  const validateFieldsDetails = () => {
        let validRequest = true;
 const { mobileNumber, referenceCode, ...otherFields } = formData;

    const allFieldsFilled = Object.values(otherFields).every(
      (value) => value !== ""
    );
    const mobileNumberValid = validateMobileNumber();

    if (!allFieldsFilled) {
        validRequest = false;
      toast.error("Kindly fill all the required details", {
        position: "bottom-center",
      });
    } else if (!mobileNumberValid) {
        validRequest = false;
      toast.error("Mobile number must be exactly 10 digits", {
        position: "bottom-center",
      });
    } 
    

    if (!validateMarks()) {
      validRequest = false;
      toast.error("Marks Obtained cannot be greater than Total Marks.", { position: "top-center" });
    }
    let doclist = documents?.map((d) => d.docName);
    let regD = Object.keys(regDetails).filter(
      (f) => f !== "documentsDto" && !doclist.includes(f)
    );

    regD.forEach((reg) => {
      const val = regDetails[reg];
      // if (val !== null && val !== 0)
      //   document.getElementById(reg).classList.remove("highlighted-input");
      // else {
      //   document.getElementById(reg).classList.add("highlighted-input");
      //   window.scroll(0, 0);
      //   validRequest = false;
      // }
    });



    if (regDetails.employee.toLowerCase() == "yes") {
      documents.forEach((dMaster) => {
        ndocuments.forEach((dUpd) => {
          if (dMaster.docName === dUpd.docName) {
          }
        });
      });
      if (ndocuments.length !== documents.length) {
        toast.error("Kindly fill all the required fields");
        window.scroll(0, 0);
        validRequest = false;
      }
    } else {
      if (!(ndocuments.length == documents.length - 1)) {
        toast.error("Kindly fill all the required fields");

        window.scroll(0, 0);
        validRequest = false;
      }
    }

    // if (validRequest) postDetails();

    return validRequest
 
  };

  function hidedoc() {
    const markSheetLabel = document.getElementsByName("marksheetLabel")[3];
    const markSheetInput = document.getElementById(`documentsDto.marksheet3`);
    const markSheetInput0 = document.getElementById(`documentsDto.marksheet0`);
    const markSheetInput1 = document.getElementById(`documentsDto.marksheet1`);
    const markSheetInput2 = document.getElementById(`documentsDto.marksheet2`);

    if (regDetails.employee === "No") {
      if (markSheetInput) {
        markSheetInput.value = "";
        markSheetInput0.value = "";
        markSheetInput1.value = "";
        markSheetInput2.value = "";
      }

      if (markSheetLabel) {
        markSheetLabel.style.display = "none";
      }
    } else {
      if (markSheetLabel) {
        markSheetLabel.style.display = "block";
      }
    }
  }

  const toggle = () => setModal(!modal);
  const loadProfile = async (mob, doc) => {
    try {

      const formData = { mobileNumber: mob, abbr: doc };
      const response = await axios.post(
        `${BaseUrl}/admin/viewDocument`,
        formData,
        {
          headers: { Authorization: localStorage.getItem('$3ingT0k3n') },
          responseType: 'arraybuffer',
        }
      );
      let contentType = response.headers['content-type'];
      if (!contentType) {
        // Fallback to checking the image data
        const uint = new Uint8Array(response.data);

        contentType = getImageType(uint);
      }

      // Create Blob based on image type
      const imageBlob = new Blob([response.data], { type: contentType });
      setImageBlob(imageBlob); // Setting Blob to state

      //   const applicantData = allData.find((c) => c.mobileNumber === mob);
      //   if (applicantData) {
      setArray({
        //   applicantName: applicantData.applicantName,
        //   applicationStatus: applicantData.applicationStatus,
        //   course: applicantData.course,
        mobileNumber: mob,
      });
      //   }
    } catch (error) {
      toast.error(error.message);
      console.error(error);
    }
  };

  const getImageType = (uint) => {
    const header = uint[0].toString(16) + uint[1].toString(16);
    switch (header) {
      case '8950': // PNG header
        return 'image/png';
      case 'ffd8': // JPEG header
        return 'image/jpeg';
      default:
        throw new Error('Unsupported image type');
    }
  };

  const [mandatoryCourse, setMandatoryCourse] = useState(null);
  const [minValue, setMinValue] = useState(0); // State for min value
  const [maxValue, setMaxValue] = useState(10);
  const [showMaxValueMessage, setShowMaxValueMessage] = useState(false);


  const handleParentCourseChange = (e) => {
    const selectedParent = e.target.value;
    setSelectedParentCourse(selectedParent);
    setSelectedOtherCourse([]);

    if (selectedParent) {

      const selectedCourse = courses.find(course => course.courseKey === selectedParent);
      setMandatoryCourse(selectedCourse?.mandatoryCourse || null);
      setMinValue(selectedCourse?.minValue);
      setMaxValue(selectedCourse?.maxValue);
    } else {
      setMandatoryCourse(null);
      setMinValue(null);
      setMaxValue(null);
    }
  };


  const handleOtherCourseChange = (selectedOptions) => {
    if (selectedOptions.length <= maxValue) {
      setSelectedOtherCourse(selectedOptions || []);
    }
  };



  const handleSelectedOtherCourses = (selectedOption) => {
    // Ensure the state only holds one selected value
    if (selectedOption.length > 1) {
      setSelectedOtherCourse([selectedOption[selectedOption.length - 1]]);
    } else {
      setSelectedOtherCourse(selectedOption);  // Single course selected
    }
  };



  const nonParentCourses = courses.filter(course => !course.isParent);


  const mandatoryCourses = courses.filter(course => course.mandatoryCourse === true);







  return (
    <>

     <Container
      className="border round py-2"
      style={{
        backgroundColor: "#f6f5f591",
        boxShadow:
          "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
        borderRadius: "9px",
      }}
    >
       <h2 style={{ color: "#000dd3", textAlign: "center" }}>Registration Form</h2>
    
        <hr />
        {lastDate && lastDate.isSameOrBefore(today) ? 
        <div className="text-center p-4" style={{ color: 'red' }}>The last date for admissions is over. We thank all learners for their interest in these courses. Stay connected with us for updates on future admissions. For any queries, please visit website on regular basis.</div>
         :
          <Form  style={{ color: "grey" }} id="">
            <Row>
              <Col md={6}>
                <FormGroup className="m-2">
                  <Label for="candidateName">Candidate/Learner Name</Label>
                  <Input
                    id="candidateName"
                    name="candidateName"
                    onChange={handleChangeReg}
                    value={formData.candidateName}
                    placeholder="Name will appear on Final Certificate"
                    type="text"
                    disabled={isOtpSent}
                  />
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup className="m-2">
                  <Label for="fatherName">Father's Name</Label>
                  <Input
                    id="fatherName"
                    name="fatherName"
                    placeholder="Enter your Father's Name"
                    type="text"
                    onChange={handleChangeReg}
                    value={formData.fatherName}
                    disabled={isOtpSent}
                  />
                </FormGroup>
              </Col>
              {/* </Row>

          <Row> */}
              <Col md={6}>
                <FormGroup className="m-2">
                  <Label for="email">Email ID</Label>
                  <Input
                    id="email"
                    name="email"
                    placeholder="Enter your Email ID"
                    type="email"
                    onChange={handleChangeReg}
                    value={formData.email}
                    disabled={isOtpSent}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup className="m-2">
                  <Label for="mobileNumber">Date of Birth</Label>
                  <Input
                    id="dateOfBirth"
                    type="date"
                    name="dateOfBirth"
                    placeholder="Select D.O.B."
                    onChange={handleChangeReg}
                    value={formData.dateOfBirth}
                    disabled={isOtpSent}
                    max={new Date().toISOString().split('T')[0]}
                    onKeyDown={(e) => e.preventDefault()}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup className="m-2">
                  <Label for="mobileNumber">Mobile Number</Label>
                  <Input
                    id="mobileNumber"
                    maxLength="10"
                    name="mobileNumber"
                    placeholder="Enter your Mobile Number"
                    type="text"
                    onChange={handleChangeReg}
                    value={formData.mobileNumber}
                    disabled={isOtpSent}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup className="m-2">
                  <Label for="whatsappNumber">Whatsapp Number</Label>
                  <Input
                    id="whatsappNumber"
                    maxLength="10"
                    name="whatsappNumber"
                    placeholder="Enter your Whatsapp Number"
                    type="text"
                    onChange={handleChangeReg}
                    value={formData.whatsappNumber}
                    disabled={isOtpSent}
                  />
                </FormGroup>
              </Col>

              {/* <Col md={6}>
                <FormGroup className="m-2">
                  <Label htmlFor="reference">
                    Reference Code
                    <span style={{ fontSize: 'small' }}> (Only for Promotional Partners)</span>
                  </Label>
                  <Input
                    id="referenceCode"

                    name="referenceCode"
                    placeholder="Enter Reference Code"
                    type="text"
                    onChange={handleChangeReg}
                    value={formData.referenceCode}

                  />
                </FormGroup>
              </Col>*/}

            </Row>

            
          </Form>}
     
    
          <Form style={{ color: "grey" }}>
            <h5 style={{ color: "#413c58" }}>Course Selection</h5>
            <h6 style={{ color: "#0f0f0f" }}>
              Select the Course in which you want to apply
            </h6>

              <Row>

                {/* Parent Course Dropdown */}
                <Col md={6} xs={12}>
                  <FormGroup className="m-2">
                    <Label for="parentCourse">Select  Course</Label>
                    <Input
                      type="select"
                      name="parentCourse"
                      id="parentCourse"
                      value={selectedParentCourse}
                      onChange={handleParentCourseChange}
                      required
                    >
                      <option value="">Select  Course</option>
                      {courses.filter(course => course.isParent)?.map((course) => (
                        <option key={course.courseKey} value={course.courseKey}>
                          {course.courseName}
                        </option>
                      ))}
                      <option value="other">Career Oriented Courses</option>
                    </Input>
                  </FormGroup>
                </Col>

                {/* Show non-parent courses when a parent course is selected */}
                {(selectedParentCourse && selectedParentCourse !== 'other') && (
                  <Col md={6} xs={12}>
                    <FormGroup className="m-2">
                      <Label for="otherCourse">Select Course under your Selection.</Label>
                      <Select
                        isMulti
                        name="otherCourse"
                        id="otherCourse"
                        required
                        options={[
                          ...(mandatoryCourses.length > 0 && !selectedOtherCourse.some(course => course.value === mandatoryCourses[0].courseKey)
                            ? [{ value: mandatoryCourses[0].courseKey, label: mandatoryCourses[0].courseName }]
                            : []),

                          ...nonParentCourses?.filter(course =>
                            !selectedOtherCourse.some(selectedCourse => selectedCourse.value === course.courseKey) &&
                            course.courseKey !== 'socialMediaMarketing' &&
                            course.courseKey !== 'digitalFreelance'
                          ).map(course => ({
                            value: course.courseKey,
                            label: course.courseName
                          }))
                        ]}


                        //   ...nonParentCourses?.map(course => ({
                        //     value: course.courseKey,
                        //     label: course.courseName
                        //   }))
                        // ]}
                        value={[
                          ...(mandatoryCourses.length > 0 && !selectedOtherCourse.some(course => course.value === mandatoryCourses[0].courseKey)
                            ? [{ value: mandatoryCourses[0].courseKey, label: mandatoryCourses[0].courseName }]
                            : []),
                          ...selectedOtherCourse
                        ]}
                        onChange={handleOtherCourseChange}

                        isValidNewOption={(inputValue) => inputValue && inputValue.length >= minValue}
                        maxSelection={maxValue}
                        noOptionsMessage="No more options"
                      />


                      {mandatoryCourses.length > 0 && !selectedOtherCourse.some(course => course.value === mandatoryCourses[0].courseKey) && (
                        <div className="text-info">
                          <p><strong></strong> {mandatoryCourses[0].courseName} is mandatory under your selected course. Kindly select the additional course/courses.</p>
                        </div>
                      )}
                      {selectedOtherCourse.length < minValue && (
                        <span className="text-danger">For the selected course, select atleast {minValue} course(s)</span>
                      )}
                      {selectedOtherCourse.length > maxValue && (
                        <span className="text-danger">You have already selected the {maxValue} courses.</span>
                      )}
                      {selectedOtherCourse.length === maxValue && (
                        <span className="text-danger">You have already selected the {maxValue} courses.</span>
                      )}

                    </FormGroup>
                  </Col>
                )}

                {selectedParentCourse === 'other' && (
                  <Col md={6} xs={12}>
                    <FormGroup className="m-2">
                      <Label for="otherCourse">Select Course under your selection</Label>
                      <Select
                        isMulti
                        name="otherCourse"
                        id="otherCourse"
                        options={nonParentCourses?.map(course => ({
                          value: course.courseKey,
                          label: course.courseName

                        }))}
                        required
                        value={selectedOtherCourse}
                        onChange={handleSelectedOtherCourses}
                        closeMenuOnSelect={true}


                      />
                      {selectedOtherCourse && selectedOtherCourse.length > 1 && (
                        <small className="text-danger">You can only select one course at a time.</small>
                      )}
                    </FormGroup>
                  </Col>
                )}

              </Row>

           
            <hr></hr>
            <h5 style={{ color: "#413c58" }}>
              Details of 12th Standard or Equivalent
            </h5>
            <h6 style={{ color: "#0f0f0f" }}>
              Fill your Details of 12th Standard or Equivalent. Ensure that these
              details should be same on the uploaded 12th document.
            </h6>
            <Row>
              <Col md={6} xs={12}>
                <FormGroup className="m-2">
                  <Label for="board">Select Board</Label>
                  <Input
                    type="select"
                    name="board"
                    id="board"
                    onChange={handleChange}
                    disabled={resubmission}
                  >
                    <option value="">Select Board</option>
                    {boards?.map((q) => (
                      <option key={q} value={q} selected={q == regDetails.board}>
                        {q}
                      </option>
                    ))}{" "}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup className="m-2">
                  <Label for="schoolYear">Passing Year</Label>
                  <Input
                    type="select"
                    name="schoolYear"
                    id="schoolYear"
                    onChange={handleChange}
                    disabled={resubmission}
                  >

                    <option value="">Year </option>
                    {year?.map((q) => (
                      <option key={q} value={q} selected={q == regDetails.schoolYear} >
                        {q}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>

              <Col md={3}>
                <FormGroup className="m-2">
                  <Label for="schoolMonth">Passing Month</Label>
                  <Input
                    type="select"
                    name="schoolMonth"
                    id="schoolMonth"
                    onChange={handleChange}
                    disabled={resubmission}
                  >
                    <option value="">Month </option>
                    {month?.map((q) => (
                      <option key={q} value={q} selected={q == regDetails.schoolMonth}>
                        {q}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup className="m-2">
                  <Label for="rollNumber">
                    12<sup>th</sup> Roll Number{" "}
                  </Label>
                  <Input
                    id="rollNumber"
                    name="rollNumber"
                    placeholder="Enter Roll number"
                    type="number"
                    min={0}
                    value={regDetails.rollNumber}
                    onChange={handleChange}
                    disabled={resubmission}
                  />
                </FormGroup>
              </Col>

              <Col md={3}>
                <FormGroup className="m-2">
                  <Label for="totalMarks">Total Marks </Label>
                  <Input
                    id="totalMarks"
                    name="totalMarks"
                    placeholder="Enter your Total Marks"
                    type="number"
                    min={0}
                    value={regDetails.totalMarks}
                    disabled={resubmission}
                    onChange={(e) => {
                      marksChange(e);
                      handleChange(e);
                    }}
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup className="m-2">
                  <Label for="marksObtained">Marks Obtained </Label>
                  <Input
                    id="marksObtained"
                    name="marksObtained"
                    placeholder="Enter Marks Obtained"
                    type="number"
                    min={0}
                    value={regDetails.marksObtained}
                    disabled={resubmission}
                    onChange={(e) => {
                      marksChange(e);
                      handleChange(e);
                    }}
                    invalid={!validateMarks()}
                  />
                  {!validateMarks() && (
                    <div className="invalid-feedback">Marks Obtained cannot be greater than Total Marks.</div>
                  )}
                </FormGroup>
              </Col>
            </Row>
            <hr></hr>
            <Row>
              <h5 style={{ color: "#413c58" }}>Address Details</h5>
              <h6 style={{ color: "#0f0f0f" }}>
                Fill your address details. Please ensure that the same address
                will be used for delivering the certificate.
              </h6>

              <Col md={4}>
                <FormGroup className="m-2">
                  <Label for="country">Select Country</Label>
                  <Input
                    type="select"
                    name="country"
                    id="country"
                    disabled={resubmission}
                    onChange={(e) => {
                      handleChange(e);
                      fetchStates(e.target.value);
                    }}
                  >
                    <option value="">Select Country</option>
                    {countries?.map((q) => (
                      <option key={q} value={q} selected={q == regDetails.country}>
                        {q}
                      </option>
                    ))}{" "}
                  </Input>
                </FormGroup>
              </Col>

              <Col md={4}>
                <FormGroup className="m-2">
                  <Label for="state">Select State</Label>
                  <Input
                    type="select"
                    name="state"
                    id="state"
                    disabled={resubmission}
                    onChange={(e) => {
                      handleChange(e);
                      fetchDistricts(e.target.value);
                    }}
                  >
                    <option value="">Select State</option>
                    {states?.map((q) => (
                      <option key={q} value={q} selected={q == regDetails.state}>
                        {q}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup className="m-2">
                  <Label for="district">Select District</Label>
                  <Input
                    type="select"
                    name="district"
                    id="district"
                    disabled={resubmission}
                    onChange={handleChange}
                  >
                    <option value="">Select District</option>
                    {districts?.map((q) => (
                      <option key={q} value={q} selected={q == regDetails.district}>
                        {q}
                      </option>
                    ))}{" "}
                  </Input>
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup className="m-2">
                  <Label for="address">Full Address </Label>
                  <Input
                    id="address"
                    name="address"
                    placeholder="Enter Address"
                    type="text"
                    onChange={handleChange}
                    value={regDetails.address}
                    disabled={resubmission}
                  />
                </FormGroup>
              </Col>

              <Col md={6}>
                <FormGroup className="m-2">
                  <Label for="pincode">Pincode </Label>
                  <Input
                    id="pincode"
                    name="pincode"
                    placeholder="Enter Pincode"
                    type="number"
                    min={0}
                    onChange={handleChange}
                    value={regDetails.pincode}
                    disabled={resubmission}
                  />
                </FormGroup>
              </Col>
            </Row>
            <hr></hr>
            <h5>Other Details</h5>
            <h6 style={{ color: "#0f0f0f" }}>
              Select Yes in case you are the University Employee of GJUS&T,
              Hisar or the ward/spouse of University Employee.
            </h6>
            <Row>
              <Col md={6} xs={12}>
                <FormGroup className="m-2">
                  <Label for="employee">
                    Are you the GJU University Employee/ Ward/ Spouse ?
                  </Label>
                  <Input
                    type="select"
                    name="employee"
                    id="employee"

                    disabled={resubmission}
                    onChange={(e) => {
                      handleChange(e);

                    }}
                  >
                    <option value="">Select Option</option>
                    <option value="Yes" selected={regDetails.employee == "Yes"}>Yes </option>
                    <option value="No" selected={regDetails.employee == "No"}>No</option>{" "}
                  </Input>
                </FormGroup>
              </Col>
              <hr></hr>
              {regDetails.employee && <>
                <h5 style={{ color: "#413c58" }}>
                  Upload Document{" "}
                  <span style={{ color: "red" }}>(1MB JPG,JPEG,PNG format only)</span>
                </h5>
                <h6 style={{ color: "#0f0f0f" }}>
                  Please note that all the documents should be uploaded in the
                  format as specified on the instructions.
                </h6>
                {documents?.map((doc, index) => (
                  <Col md={6} name="marksheetLabel">
                    <FormGroup className="m-2">
                      <Label for="documentsDto.marksheet">
                        {doc.docName} (1MB JPG,JPEG,PNG ONLY)
                      </Label>
                      <Input
                        id={`documentsDto.marksheet${index}`}
                        name="documentsDto.marksheet"
                        type="file"
                        onChange={(e) =>
                          handleChange({
                            target: {
                              name: doc.docName,
                              value: e.target.files[0],
                              type: "document",
                              id: e.target.id,
                            },
                          })
                        }
                      />
                    </FormGroup>
                  </Col>
                ))}</>}
            </Row>
          </Form>
          {/* <Form className="text-center">
            <Button color="success" onClick={validateFieldsDetails}>
              {" "}
              Save{" "}
            </Button>
          </Form>{" "} */}


          {isOtpSent && (
              <Row className="justify-content-center">
                <Col md={4}>
                  <FormGroup className="m-2">
                    <Label for="otp">Enter OTP</Label>
                    <Input
                      id="otp"
                      name="otp"
                      placeholder="Enter the OTP sent to your mobile"
                      type="text"
                      onChange={handleOtpChange}
                      value={otp}
                    />
                  </FormGroup>
                </Col>
              </Row>
            )}

            <div className="text-center">
              {!isOtpSent && (
                <Button color="primary" type="button" onClick={sendOtp}>
                  Proceed
                </Button>
              )}
              {isOtpSent && (
                <>
                  <Button color="success" type="button" className="me-3" onClick={postDetails}>
                    Register
                  </Button>

                  <Button color="danger" onClick={sendOtp} disabled={timer > 0}>
                    Resend OTP {timer > 0 && `(${timer})`}
                  </Button>
                </>
              )}
            </div>
        
      <Modal isOpen={modal} toggle={toggle} fullscreen id="Modal2">
        <ModalHeader>View Document</ModalHeader>
        <ModalBody className="text-center">
          {imageBlob && (
            <img width={'100%'} src={URL.createObjectURL(imageBlob)} alt="Fetched Image" />
          )}

        </ModalBody>

      </Modal>
    </Container>
    </>
  );
};

export default Admissions;
